// Generated TypeScript file - DO NOT EDIT
// Last updated: 2025-11-18T15:13:55.277Z
import { SuperTooltipTemplate } from './types';

export type SuperTooltipTemplateId =
  | 'accomplishments'
  | 'profile-avatar-image'
  | 'cover-image'
  | 'extras-details'
  | 'extras-links'
  | 'extras-pdf'
  | 'extras-slides'
  | 'extras-video'
  | 'intro-video'
  | 'offers-banner'
  | 'profile-banner'
  | 'profile-title'
  | 'profile-story';

export const templatesByID: Record<string, SuperTooltipTemplate[]> = {
  accomplishments: [
    {
      title: 'Accomplishments',
      content:
        'Highlight any certifications, awards, or experiences that show your expertise and credibility as a fitness professional.\n\nExamples used by our successful creators:',
      tips: [
        'Think about what makes you qualified to lead others — whether it’s formal training, special achievements, or years of experience',
        'This is your chance to show users why they can trust and learn from you!',
      ],
      tags: [
        'Certified Personal Trainer',
        'Certified Nutritionist',
        'Cookbook Author',
        'Former Division 1 Track & Field Athlete',
        'The Founder of Cross Projects',
        'NCCPT Certified Personal Trainer',
        "Former NPC Men's Physique Competitor",
      ],
      ctaLink: '',
      ctaLabel: '',
      readMoreText: '',
      readMoreLink: '#',
      readMoreLabel: 'Read more',
      layout: 'one-column',
      frontMatter: {
        templateId: 'accomplishments',
        order: 10,
        name: 'Accomplishments',
      },
      type: 'basic',
      imageAlt: 'Placeholder image',
    },
  ],
  'profile-avatar-image': [
    {
      title: 'Avatar Image',
      content: '',
      tips: [
        'Choose a clear photo of your face where you’re easy to recognize.',
        'Think good lighting, minimal distractions, and a friendly expression.',
        'This will be your profile photo, so pick something that feels like you!',
      ],
      tags: [],
      ctaLink: '',
      ctaLabel: '',
      readMoreText: 'Set up your profile on superstar level with',
      readMoreLink: 'https://www.joinplaybook.com/handbook',
      readMoreLabel: 'The Handbook',
      layout: 'two-column',
      frontMatter: {
        templateId: 'profile-avatar-image',
        name: 'Avatar Image',
        order: 10,
      },
      type: 'single-image',
      imageUrl: 'avatar.png',
      imageAlt: 'Examples of avatars of our most successful creators',
    },
  ],
  'cover-image': [
    {
      title: 'Cover image',
      content:
        'Shown in Discovery section and will be displayed when users search for trainers.',
      tips: ['Make sure it represents you well and stands out!'],
      tags: [],
      ctaLink: '',
      ctaLabel: '',
      readMoreText: 'Get your profile to superstar level with',
      readMoreLink: 'https://www.joinplaybook.com/handbook',
      readMoreLabel: 'The Handbook',
      layout: 'one-column',
      frontMatter: {
        templateId: 'cover-image',
        order: 10,
        name: 'Cover image',
        version: '1.0s',
        author: 'product-team',
      },
      type: 'single-image',
      imageUrl: 'cover-image-bg.png',
      imageAlt: 'Cover image',
    },
    {
      title: 'Cover Image',
      content: 'Examples of cover images of some successful creators:',
      tips: [],
      tags: [],
      ctaLink: '',
      ctaLabel: '',
      readMoreText: 'Get your profile to superstar level with',
      readMoreLink: 'https://www.joinplaybook.com/handbook',
      readMoreLabel: 'The Handbook',
      layout: 'two-column',
      frontMatter: {
        templateId: 'cover-image',
        order: 30,
        name: 'Next Steps',
      },
      type: 'two-image',
      imageUrls: ['cover-image-1.png', 'cover-image-2.png'],
      imageAlts: ['Cover image 1', 'Cover image 2'],
    },
  ],
  'extras-details': [
    {
      title: 'Your Extras',
      content:
        'The Extras section lets you share external resources like links, slides, educational videos or PDFs to give your audience added value beyond workouts.',
      tips: [
        'Feature affiliate links, playlists, eBooks, or any other content you want to share.',
        'Rename and customize your Extras tab to fit your brand.',
        'Make everything easily accessible to your subscribers and customers.',
      ],
      tags: [],
      ctaLink: '',
      ctaLabel: '',
      readMoreText: 'Check out our full help article',
      readMoreLink:
        'https://help.playbookapp.io/en/articles/11794438-how-to-use-the-extras-tab-to-add-links-and-resources-to-your-channel',
      readMoreLabel: 'link:here',
      layout: 'two-column',
      frontMatter: {
        templateId: 'extras-details',
        order: 10,
        name: 'Extras',
      },
      type: 'single-image',
      imageUrl: 'extras-details-cover.png',
      imageAlt: 'Cover image',
    },
  ],
  'extras-links': [
    {
      title: 'What are Links?',
      content:
        'Add and manage external links for your Extras tab. Use them to share promotions, resources, or LinkTree-style pages with your subscribers.',
      tips: [
        'Add a custom Banner Image for your link; if none is uploaded, the link title will be shown instead',
      ],
      tags: [],
      ctaLink: '',
      ctaLabel: '',
      readMoreText: 'Check out our full help article',
      readMoreLink:
        'https://help.playbookapp.io/en/articles/11794438-how-to-use-the-extras-tab-to-add-links-slides-and-pdfs',
      readMoreLabel: 'link:here',
      layout: 'one-column',
      frontMatter: {
        templateId: 'extras-links',
        order: 10,
        name: 'Extras',
      },
      type: 'single-image',
      imageUrl: 'link-extras.png',
      imageAlt: 'Cover image',
    },
  ],
  'extras-pdf': [
    {
      title: 'What are PDFs?',
      content:
        'Share in-depth materials your audience can read and save for later—like guides, checklists, or full programs. PDFs must be created outside of Playbook before you upload them here.',
      tips: [
        'Add a custom Banner Image for your PDF; if none is uploaded, the PDF title will be shown instead',
      ],
      tags: [],
      ctaLink: '',
      ctaLabel: '',
      readMoreText: 'Check out our full help article',
      readMoreLink:
        'https://help.playbookapp.io/en/articles/11794438-how-to-use-the-extras-tab-to-add-links-and-resources-to-your-channel',
      readMoreLabel: 'link:here',
      layout: 'one-column',
      frontMatter: {
        templateId: 'extras-pdf',
        order: 10,
        name: 'Extras',
      },
      type: 'single-image',
      imageUrl: 'pdf-extras.png',
      imageAlt: 'Cover image',
    },
  ],
  'extras-slides': [
    {
      title: 'What are Slides?',
      content:
        'Upload sequenced images to showcase your content as if it were a presentation',
      tips: [
        'Add a custom Banner Image for your slide; if none is uploaded, the slide title will be shown instead',
      ],
      tags: [],
      ctaLink: 'https://playbookapp.io/creators/slide-templates',
      ctaLabel: 'Go to templates',
      readMoreText: 'Check out our full help article',
      readMoreLink:
        'https://help.playbookapp.io/en/articles/11794438-how-to-use-the-extras-tab-to-add-links-and-resources-to-your-channel',
      readMoreLabel: 'link:here',
      layout: 'one-column',
      frontMatter: {
        templateId: 'extras-slides',
        order: 10,
        name: 'Extras',
      },
      type: 'single-image',
      imageUrl: 'slides-extras.png',
      imageAlt: 'Cover image',
    },
  ],
  'extras-video': [
    {
      title: 'What are Videos?',
      content:
        'Upload videos that cover topics like nutrition tips, mindset talks, overviews, or anything else your audience needs.',
      tips: [
        'Add a custom Banner Image for your video to make it stand out more',
      ],
      tags: [],
      ctaLink: '',
      ctaLabel: '',
      readMoreText: 'Check out our full help article',
      readMoreLink:
        'https://help.playbookapp.io/en/articles/12532288-how-to-use-the-video-template',
      readMoreLabel: 'link:here',
      layout: 'one-column',
      frontMatter: {
        templateId: 'extras-video',
        order: 10,
        name: 'Extras',
      },
      type: 'single-image',
      imageUrl: 'video-extras.png',
      imageAlt: 'Cover image',
    },
  ],
  'intro-video': [
    {
      title: 'Introduction Video',
      content:
        'Your intro video is extremely important since it’s the first thing a user will see when he or she downloads your app.\n\nHere’s a super simple script for your intro video:',
      tips: [
        'Hi guys, welcome to my app! I can’t wait for you to check out all of my workouts. I’ll be posting new content every week. Be sure to let me know what you think!',
      ],
      tags: [],
      ctaLink: '',
      ctaLabel: '',
      readMoreText: '​You can find other sample scripts and tips',
      readMoreLink:
        'https://www.joinplaybook.com/videos/how-to-film-an-intro-video',
      readMoreLabel: 'link:here',
      layout: 'two-column',
      frontMatter: {
        templateId: 'intro-video',
        order: 10,
        name: 'Cover image',
        version: '1.0s',
        author: 'product-team',
      },
      type: 'video',
      videoThumbnailUrl: 'intro-thumbnail.png',
      videoUrl:
        'https://d3l5vala1x2h4r.cloudfront.net/1705621907726_1705621902.010694-output-compressed..mp4',
    },
  ],
  'offers-banner': [
    {
      title: 'Sell Individual Programs and Extras',
      content:
        "Creating an offer allows you to put a price tag on multiple items (or a single item!) and sell them as standalone products.\n\nYou can package anything together: A PDF, a few Videos, even Workout Programs and Community access, however you'd like.",
      tips: [],
      tags: [],
      ctaLink: '',
      ctaLabel: '',
      readMoreText: '',
      readMoreLink: '#',
      readMoreLabel: 'Read more',
      layout: 'one-column',
      frontMatter: {
        templateId: 'offers-banner',
        order: 10,
        name: 'Offers Banner',
      },
      type: 'single-image',
      imageUrl: 'offers-intro.png',
      imageAlt: 'Cover image',
    },
    {
      title: 'Bundle up!',
      content:
        "You're packaging things together, consider offering them at a discount to maximize interest from your users.\n\nGet inspired with these top strategies from some of our most successful creators",
      tips: [],
      tags: [],
      ctaLink: '',
      ctaLabel: '',
      readMoreText: '',
      readMoreLink: '#',
      readMoreLabel: 'Read more',
      layout: 'one-column',
      frontMatter: {
        templateId: 'offers-banner',
        order: 20,
        name: 'Offers Banner',
      },
      type: 'single-image',
      imageUrl: 'offers-format.png',
      imageAlt: 'Cover image',
    },
    {
      title: 'Bundle up!',
      content: '',
      tips: [],
      tags: [],
      ctaLink: '',
      ctaLabel: '',
      readMoreText: '',
      readMoreLink: '#',
      readMoreLabel: 'Read more',
      layout: 'one-column',
      frontMatter: {
        templateId: 'offers-banner',
        order: 30,
        name: 'Offers Banner',
      },
      type: 'single-image',
      imageUrl: 'offers-discounts.png',
      imageAlt: 'Cover image',
    },
    {
      title: 'Bundle up!',
      content: '',
      tips: [],
      tags: [],
      ctaLink: '',
      ctaLabel: '',
      readMoreText: '',
      readMoreLink: '#',
      readMoreLabel: 'Read more',
      layout: 'one-column',
      frontMatter: {
        templateId: 'offers-banner',
        order: 40,
        name: 'Offers Banner',
      },
      type: 'single-image',
      imageUrl: 'offers-theme.png',
      imageAlt: 'Cover image',
    },
  ],
  'profile-banner': [
    {
      title: 'Banner Image',
      content:
        '<img src="canva-logo.png"> We have partnered with Canva to provide you with a template that you can use to easily design your banner.',
      tips: [],
      tags: [],
      ctaLink:
        'https://www.canva.com/design/DAFvBfB0k5c/brvdLPiGdKsZEQvticaTOQ/view',
      ctaLabel: 'Go to templates',
      readMoreText: '',
      readMoreLink: '#',
      readMoreLabel: 'Read more',
      layout: 'one-column',
      frontMatter: {
        templateId: 'profile-banner',
        order: 10,
        name: 'Profile Banner',
      },
      type: 'single-image',
      imageUrl: 'canva.png',
      imageAlt: 'Canva',
    },
    {
      title: 'Profile Banner',
      content:
        'Displayed at the top of your profile, choose an eye-catching image that reflects your personality and style.',
      tips: [],
      tags: [],
      ctaLink: '',
      ctaLabel: '',
      readMoreText: '',
      readMoreLink: '#',
      readMoreLabel: 'Read more',
      layout: 'one-column',
      frontMatter: {
        templateId: 'profile-banner',
        order: 20,
        name: 'Profile Banner',
      },
      type: 'single-image',
      imageUrl: 'profile-banner.png',
      imageAlt: 'Profile Banner',
    },
    {
      title: 'Profile Banner',
      content: 'Examples of profile banners of our successful creators:',
      tips: [],
      tags: [],
      ctaLink: '',
      ctaLabel: '',
      readMoreText: '',
      readMoreLink: '#',
      readMoreLabel: 'Read more',
      layout: 'one-column',
      frontMatter: {
        templateId: 'profile-banner',
        order: 30,
        name: 'Profile Banner',
      },
      type: 'two-image',
      imageUrls: [
        'profile-banner-example-1.png',
        'profile-banner-example-2.png',
      ],
      imageAlts: ['Cover image 1', 'Cover image 2'],
    },
  ],
  'profile-title': [
    {
      title: 'Profile Title',
      content:
        'Add your title (i.e. Fitness Instructor, Bodybuilder, Yogi Guru). Feel free to get creative with it!\n\nExamples of titles used by our successful creators:',
      tips: [],
      tags: [
        'Metabolic MELT Method | Fat Loss Specialist',
        'Your Meditation Coach. Mind & Body Connection',
        'FUNctional Fitness | Nutrition',
        'Yoga and Fitness Integration for Stressfree Lifestyle',
      ],
      ctaLink: '',
      ctaLabel: '',
      readMoreText: '',
      readMoreLink: '#',
      readMoreLabel: 'Read more',
      layout: 'one-column',
      frontMatter: {
        templateId: 'profile-title',
        order: 10,
        name: 'Profile title',
      },
      type: 'basic',
      imageAlt: 'Placeholder image',
    },
  ],
  'profile-story': [
    {
      title: 'Profile Story',
      content:
        "Think about the experiences that shaped you and why you're passionate about helping others.",
      tips: [
        "Think about the experiences that shaped you and why you're passionate about helping others.",
        'Let your users know what drives you and how you’re here to support them!',
      ],
      tags: [],
      ctaLink: '',
      ctaLabel: '',
      readMoreText: '',
      readMoreLink: '#',
      readMoreLabel: 'Read more',
      layout: 'two-column',
      frontMatter: {
        templateId: 'profile-story',
        order: 10,
        name: 'Profile Story',
      },
      type: 'two-image',
      imageUrls: ['story-1.png', 'story-2.png'],
      imageAlts: ['Story', 'Story'],
    },
  ],
};

export function getTemplatesByID(
  templateId: SuperTooltipTemplateId,
): SuperTooltipTemplate[] {
  return templatesByID[templateId] || [];
}

export const availableTemplateIDs: SuperTooltipTemplateId[] = [
  'accomplishments',
  'profile-avatar-image',
  'cover-image',
  'extras-details',
  'extras-links',
  'extras-pdf',
  'extras-slides',
  'extras-video',
  'intro-video',
  'offers-banner',
  'profile-banner',
  'profile-title',
  'profile-story',
];
